import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/assets/main.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";

import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
Vue.config.devtools = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
